import { render, staticRenderFns } from "./batchBindModal.vue?vue&type=template&id=2fa6ef14&scoped=true"
import script from "./batchBindModal.vue?vue&type=script&lang=js"
export * from "./batchBindModal.vue?vue&type=script&lang=js"
import style0 from "./batchBindModal.vue?vue&type=style&index=0&id=2fa6ef14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa6ef14",
  null
  
)

export default component.exports